import Api from "../axios";

export const updateNotice = (noticeData) => {
  return Api.post("update_notice", noticeData);
};
